import { render } from "./IRC.vue?vue&type=template&id=17828272&scoped=true"
import script from "./IRC.vue?vue&type=script&lang=js"
export * from "./IRC.vue?vue&type=script&lang=js"

import "./IRC.vue?vue&type=style&index=0&id=17828272&scoped=true&lang=css"

import exportComponent from "/build/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17828272"]])

export default __exports__